import type { ExplorationFilter } from '../../types/exploration';

export function appendFilter(
  filters: ExplorationFilter[],
  filter: ExplorationFilter
): ExplorationFilter[] {
  const exists = filters.some((f) => {
    if (f.type !== filter.type) return false;
    if (f.type === 'capacity' && filter.type === 'capacity') {
      return f.min === filter.min && f.max === filter.max;
    }
    if (f.type === 'tag' && filter.type === 'tag') {
      return f.key === filter.key && f.value === filter.value;
    }
    if ('value' in f && 'value' in filter) {
      return f.value === filter.value;
    }
    return false;
  });

  if (exists) return filters;
  return [...filters, filter];
}
